<script setup>
import { computed } from 'vue';
const { strong } = defineProps({
  // Use strong prop when this dropdown is stacked inside another dropdown: it gets a strong border. (The Chrome
  // stacked backdrop-blur workaround that lived here went away with the kit's opaque popover.)
  strong: {
    type: Boolean,
    default: false,
  },
});

const borderClass = computed(() => {
  return strong ? 'border-n-strong' : 'border-n-weak';
});
</script>

<template>
  <div class="absolute">
    <ul
      class="text-sm bg-polaris-popover text-polaris-popover-foreground border rounded-polaris-md shadow-sm py-2 n-dropdown-body gap-2 grid list-none px-2 reset-base relative"
      :class="borderClass"
    >
      <slot />
    </ul>
  </div>
</template>
